import { Problems, Work } from '../types';

const TARGETED_BEFORE_SPIRAL_REVIEW_MESSAGE =
  'Finish Targeted skills before working on Spiral Review skills';

const DOLLARS_ONLY_MESSAGE = 'You may only work on skills worth a point $';

type SquareType = { id: string; type?: string };

/**
 * True when the class requires Targeted skills to be finished and this
 * assignment still has Targeted points remaining.
 */
export const areSpiralReviewSquaresLocked = (
  requireStudentsToFinishAssignedSkills: boolean,
  work: Pick<Work, 'type' | 'newSkillPoints' | 'newSkillRequired'>
): boolean => {
  if (!requireStudentsToFinishAssignedSkills) return false;
  if (work.type !== 'ASSIGNMENT') return false;

  const required = work.newSkillRequired ?? 0;

  if (required <= 0) return false;

  return (work.newSkillPoints ?? 0) < required;
};

export const isSpiralReviewSquareLocked = (
  problem: Pick<SquareType, 'type'>,
  requireStudentsToFinishAssignedSkills: boolean,
  work: Pick<Work, 'type' | 'newSkillPoints' | 'newSkillRequired'>
): boolean =>
  problem.type === 'SPIRAL_REVIEW' &&
  areSpiralReviewSquaresLocked(requireStudentsToFinishAssignedSkills, work);

export const getSquareRestrictionMessage = ({
  isDollar,
  dollarsOnly,
  isSpiralReviewLocked,
}: {
  isDollar: boolean;
  dollarsOnly: boolean;
  isSpiralReviewLocked: boolean;
}): string | undefined => {
  if (isSpiralReviewLocked) return TARGETED_BEFORE_SPIRAL_REVIEW_MESSAGE;
  if (dollarsOnly && !isDollar) return DOLLARS_ONLY_MESSAGE;

  return undefined;
};

export const getReplacementTargetedId = (
  problems: Problems,
  dollars: string[]
): string | undefined => {
  const targeted = Object.values(problems).filter(
    (problem): problem is SquareType =>
      'type' in problem && problem.type === 'NEW_SKILL'
  );
  const withDollar = targeted.find(problem => dollars.includes(problem.id));

  return (withDollar ?? targeted[0])?.id;
};
